/**
 * Provider for `visitorId`
 * @module
 */

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'visitorId',

  getter: [
    'stores/visitor_id',
    /**
     * @param {Store} VisitorIdStore
     * @return {string}
     */
    function(VisitorIdStore) {
      return VisitorIdStore.getRandomId();
    },
  ],
};
